export default __webpack_public_path__ + "static/20-0130df6dd17397913eda01a8b324b589.webp";